<template>
  <v-chip :color="statusColor(value)" size="small" variant="tonal">
    {{ humanize(value) }}
  </v-chip>
</template>

<script setup>
import { humanize, statusColor } from "../utils";

defineProps({ value: { type: [String, Number, Boolean], default: "-" } });
</script>
